import * as types from '../../constants/log/inventoryTransactionLogConstants';

export const inventoryTransactionLogListRequest = (
  {
    page,
    pageLength,
    beginDate,
    endDate,
    account,
    transactionType,
    callback,
    error
  }
) => ({
  type: types.INVENTORY_TRANSACTIONLOG_LIST_REQUEST,
  page,
  pageLength,
  beginDate,
  endDate,
  account,
  transactionType,
  callback,
  error,
});

export const inventoryTransactionLogList = (list) => ({
  type: types.INVENTORY_TRANSACTIONLOG_LIST,
  list
});

export const setTotalCount = (totalCount) => ({
  type: types.SET_TOTAL_COUNT,
  totalCount,
});

export const setInventoryTransactionLogPagination = (
  page, totalCount, beginDate, endDate, searchCode, searchString
) => ({
  type: types.SET_INVENTORY_TRANSACTIONLOG_PAGINATION,
  page,
  totalCount,
  beginDate,
  endDate,
  searchCode,
  searchString,
});

export const inventoryTransactionLogPageReset = () => ({
  type: types.INVENTORY_TRANSACTIONLOG_PAGE_RESET,
});

export const itemTransactionLogListRequest = ({
  page,
  pageLength,
  beginDate,
  endDate,
  account,
  transactionType,
  itemId,
  callback,
  error
}) => ({
  type: types.ITEM_TRANSACTION_LOG_LIST_REQUEST,
  page,
  pageLength,
  beginDate,
  endDate,
  account,
  transactionType,
  itemId,
  callback,
  error
})
